import type {BasicFolderItem} from 'folder-items/FileConstants';

export const EXPORT_EVENT_PAYLOADS = {
  EXPORT_PATENTSAFE_STARTED: {} as {
    fileId: string;
  },
  EXPORT_PATENTSAFE_COMPLETED: {} as {
    fileId: string;
    item: Pick<BasicFolderItem, 'thirdPartyStorageServiceData'>;
  },
  EXPORT_PATENTSAFE_FAILED: {} as {
    fileId: string;
  },
} as const;

export type ExportEventPayload = typeof EXPORT_EVENT_PAYLOADS;
